import React from 'react';
import { inp, MsgBox } from './shared';

interface Props {
  categories: string[];
  currency: string;
  categoryBudgets: Record<string, number>;
  newCat: string; setNewCat: (s: string) => void;
  catMsg: string;
  catBusy: boolean;
  onAdd: () => void;
  onRemove: (cat: string) => void;
  onBudgetChange: (cat: string, value: string) => void;
  onSaveBudgets: () => void;
}

export function SettingsCategories(p: Props) {
  return (
    <div style={{ animation: 'fadeSlideIn .25s ease-out' }}>
      <div style={{ fontSize: 16, fontWeight: 600, color: 'var(--text)', marginBottom: 4 }}>Categories &amp; budgets</div>
      <div style={{ fontSize: 12, color: 'var(--text3)', marginBottom: 20 }}>Manage order categories and set monthly budget targets per category.</div>

      <div style={{ display: 'flex', gap: 8, marginBottom: 14 }}>
        <input
          value={p.newCat}
          onChange={e => p.setNewCat(e.target.value)}
          placeholder="New category"
          style={{ ...inp, flex: 1 }}
          onKeyDown={e => { if (e.key === 'Enter') p.onAdd(); }}
        />
        <button className="hbtn acc" disabled={p.catBusy || !p.newCat.trim()} onClick={p.onAdd}
          style={{ borderRadius: 8, padding: '8px 16px', fontSize: 12, whiteSpace: 'nowrap' }}>+ Add</button>
      </div>
      <MsgBox msg={p.catMsg} />

      {p.categories.map(cat => (
        <div key={cat} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '10px 0', borderBottom: '1px solid var(--border)' }}>
          <span style={{ flex: 1, fontSize: 13, fontWeight: 500 }}>{cat}</span>
          <span style={{ fontSize: 11, color: 'var(--text3)' }}>{p.currency}</span>
          <input
            type="number"
            value={p.categoryBudgets[cat] ?? 0}
            onChange={e => p.onBudgetChange(cat, e.target.value)}
            style={{ ...inp, width: 90, textAlign: 'right', padding: '6px 8px' }}
            placeholder="0"
          />
          <span style={{ fontSize: 10, color: 'var(--text3)' }}>/mo</span>
          <button onClick={() => p.onRemove(cat)}
            style={{ background: 'none', border: '1px solid var(--border)', color: 'var(--text3)', cursor: 'pointer', fontSize: 12, padding: '4px 8px', borderRadius: 6, fontFamily: 'var(--font)' }}>
            x
          </button>
        </div>
      ))}

      <div style={{ marginTop: 16 }}>
        <button className="hbtn acc" onClick={p.onSaveBudgets} disabled={p.catBusy}
          style={{ borderRadius: 8, padding: '10px 24px', fontSize: 13, fontWeight: 600 }}>
          Save budgets
        </button>
      </div>
    </div>
  );
}
